const Layout = r => require(['@/pages/PageLayout'], r)

const ArchivesStudentIndex = r => require(['@/v3/modules/datamanage/views/study/archives/student/index'], r)
const ArchivesTeacherIndex = r => require(['@/v3/modules/datamanage/views/study/archives/teacher/index'], r)
const ArchivesTeacherDetail = r => require(['@/v3/modules/datamanage/views/study/archives/teacher/detail'], r)
const ArchivesStudentDetail = r => require(['@/v3/modules/datamanage/views/study/archives/student/detail'], r)

// 大数据中心
const DataStudent = r => require(['@/v3/modules/datamanage/views/study/student'], r)
const DataClass = r => require(['@/v3/modules/datamanage/views/study/class'], r)
const DataClassLayout = r => require(['@/v3/modules/datamanage/views/study/class/layout'], r)
const DataClassMistakes = r => require(['@/v3/modules/datamanage/views/study/class/mistakes'], r)
const DataClassWeakPoint = r => require(['@/v3/modules/datamanage/views/study/class/weakPoint'], r)
const DataStudentLayout = r => require(['@/v3/modules/datamanage/views/study/student/layout'], r)
const DataStudentMistakes = r => require(['@/v3/modules/datamanage/views/study/student/mistakes'], r)
const DataStudentWeakPoint = r => require(['@/v3/modules/datamanage/views/study/student/weakPoint'], r)

const ArchivesRouter = {
  path: '/study/archives',
  meta: { auth: 'Study', keepAlive: true },
  component: Layout,
  children: [
    {
      path: '/study/archives/student',
      name: 'archives-student',
      meta: { auth: 'Archives-Student', keepAlive: true },
      component: ArchivesStudentIndex
    },
    {
      path: '/study/archives/teacher',
      name: 'archives-teacher',
      meta: { auth: 'Archives-Teacher', keepAlive: true },
      component: ArchivesTeacherIndex
    },
    {
      path: '/study/archives/teacher/detail',
      meta: { auth: 'Archives-Teacher' },
      component: ArchivesTeacherDetail
    },
    {
      path: '/study/archives/student/detail',
      meta: { auth: 'Archives-Student' },
      component: ArchivesStudentDetail
    }
  ]
}

const bigDataRouter = {
  path: '/study',
  meta: { auth: 'Study', keepAlive: true },
  component: Layout,
  children: [
    {
      path: '/study/student',
      meta: { auth: 'Study-Student', keepAlive: true },
      component: DataStudent
    },
    {
      path: '/study/class',
      meta: { auth: 'Study-Class', keepAlive: true },
      component: DataClass
    }
  ]
}

const bigDataDetailRouter = {
  path: '/study/track',
  meta: { auth: 'Study' },
  component: Layout,
  children: [
    {
      path: '/study/class/track/:classId/:subjectCode',
      meta: { auth: 'Study-Class-Track' },
      component: DataClassLayout,
      redirect: '/study/class/track/mistakes/:classId/:subjectCode',
      children: [
        {
          path: '/study/class/track/mistakes/:classId/:subjectCode',
          name: 'study-class-mistakes',
          component: DataClassMistakes
        },
        {
          path: '/study/class/track/weakPoint/:classId/:subjectCode',
          name: 'study-class-weak',
          component: DataClassWeakPoint
        }
      ]
    },
    {
      path: '/study/student/track/:studentId/:subjectCode',
      meta: { auth: 'Study-Student-Track' },
      component: DataStudentLayout,
      redirect: '/study/student/track/mistakes/:studentId/:subjectCode',
      children: [
        {
          path: '/study/student/track/mistakes/:studentId/:subjectCode',
          name: 'study-student-mistakes',
          component: DataStudentMistakes
        },
        {
          path: '/study/student/track/weakPoint/:studentId/:subjectCode',
          name: 'study-student-weak',
          component: DataStudentWeakPoint
        }
      ]
    }
  ]
}

export { ArchivesRouter, bigDataRouter, bigDataDetailRouter }
